import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import AlertBox from "components/form/AlertBox";
import Title from "components/form/Title";
import useOnewayPickupPeriodicHikeTimeSubmit from "hooks/OnewayPeriodicHikeTimeSubmit";
import DynamicOnewayPeriodicHikeTimeInput from "components/form/DynamicOnewayPeriodicHikeTimeInput";
import OnewayPickupSelectCity from "components/form/OneWayselectCity";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
// import DateRangePicker from "components/form/InputDateRangePicker";

const OnewayPickupPeriodicHikeTimeDrawer = ({ id }) => {
    const {
        handleVehicleCategoryChange,
        setDataInput,
        dataInput,
        handleChangeInput,
        register,
        handleSubmit,
        fromCity,
        toCity,
        onSubmit,
        handlefromCityChange,
        handletoCityChange,
        handleStartTimeChange,
        handleEndTimeChange,
        trigger,
        errors,
        startTimeOptions,
        setOpen,
        open,
        loading,
    } = useOnewayPickupPeriodicHikeTimeSubmit(id);

    return (
        <>
            <AlertBox
                setOpen={setOpen}
                open={open}
                errmsg={"Error: Same time should not allow"}
            />
            <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
                {id ? (
                    <Title
                        title={"Edit Oneway Pickup Periodic Hike Time"}
                        description={""}
                    />
                ) : (
                    <Title
                        title={"Add Oneway Pickup Periodic Hike Time"}
                        description={""}
                    />
                )}
            </div>
            <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
                        <div className="gap-3 mb-6">
                            <div className="grid grid-cols-6 gap-3 mb-6" style={{ display: "flex", justifyContent: "space-between" }}>

                                <div style={{ width: "100%" }} >
                                    <LabelArea label={"From City"} />
                                    <OnewayPickupSelectCity
                                        register={register}
                                        label="From City"
                                        name="from_city"
                                        type="text"
                                        placeholder={"--Choose--"}
                                        selectedCity={fromCity}
                                        handleCityChange={handlefromCityChange}

                                    />
                                     <Error errorName={errors.from_city} />
                                </div>
                               
                                <div style={{ width: "100%" }} >
                                    <LabelArea label={"To City"} />
                                    <OnewayPickupSelectCity
                                        register={register}
                                        label="To City"
                                        name="to_city"
                                        type="text"
                                        placeholder={"--Choose--"}
                                        selectedCity={toCity}
                                        handleCityChange={handletoCityChange}

                                    />
                                         <Error errorName={errors.to_city} />
                                </div>
                           
                            </div>
                        </div>

                        <DynamicOnewayPeriodicHikeTimeInput
                            register={register}
                            trigger={trigger}
                            errors={errors}
                            dataInput={dataInput}
                            setDataInput={setDataInput}
                            handleChange={handleChangeInput}
                            handleVehicleCategoryChange={handleVehicleCategoryChange}
                            handleStartTimeChange={handleStartTimeChange}
                            handleEndTimeChange={handleEndTimeChange}
                            StartTimeOptions={startTimeOptions}
                        />
                    </div>

                    <DrawerButton
                        isSubmitting={loading}
                        id={id}
                        title={id ? "Update" : "Submit"}
                    />
                </form>
            </Scrollbars>
        </>
    );
};

export default OnewayPickupPeriodicHikeTimeDrawer;
